function parseBooleanFlag(value) {
  if (typeof value === 'boolean') {
    return value
  }

  if (typeof value !== 'string') {
    return false
  }

  const normalizedValue = value.trim().toLowerCase()

  return normalizedValue === '1' || normalizedValue === 'true' || normalizedValue === 'yes'
}

export const PUBLIC_LIVE_SESSION_APP_OWNED_AGORA_FLAG =
  'publicLiveSessionAppOwnedAgora'

export function getPublicLiveSessionRtcMigrationDebugInfo({
  sessionRoutingDecision,
} = {}) {
  const routingFlagEnabled =
    sessionRoutingDecision?.featureFlags?.[PUBLIC_LIVE_SESSION_APP_OWNED_AGORA_FLAG] === true

  const envFlagEnabled = parseBooleanFlag(
    import.meta.env.VITE_ENABLE_PUBLIC_LIVE_SESSION_APP_OWNED_AGORA,
  )
  const envForceDisabled = parseBooleanFlag(
    import.meta.env.VITE_DISABLE_PUBLIC_LIVE_SESSION_APP_OWNED_AGORA,
  )

  const enabled = envForceDisabled ? false : routingFlagEnabled || envFlagEnabled

  return {
    enabled,
    selectedSurface: enabled ? 'app-owned-agora-surface' : 'legacy-agora-component',
    routingFlagEnabled,
    envFlagEnabled,
    envForceDisabled,
  }
}

export function resolvePublicLiveSessionRtcMigrationEnabled({
  sessionRoutingDecision,
} = {}) {
  return getPublicLiveSessionRtcMigrationDebugInfo({ sessionRoutingDecision }).enabled
}
